import { FC, useEffect } from "react";
import { useI18n } from "../../../hooks/useTranslations";
import { MaintenanceType } from "../../../http/maintenanceTypes/types";
import Form from "../../ui/Form";
import FormField from "../../ui/FormField";
import FormFieldsContainer from "../../ui/FormFieldsContainer";
import Input from "../../ui/Input";

export interface MaintenanceTypeFormBody {
  name: string;
}

type MaintenanceTypeFormProps = {
  maintenanceType?: MaintenanceType | null;
  onSubmit: (form: MaintenanceTypeFormBody) => Promise<void>;
  isDisabled?: boolean;
  isLoading?: boolean;
};

const MaintenanceTypeForm: FC<MaintenanceTypeFormProps> = ({
  maintenanceType,
  onSubmit,
  isDisabled,
  isLoading,
}: MaintenanceTypeFormProps) => {
  const i18n = useI18n();

  const defaultValues = { name: maintenanceType?.name };

  return (
    <Form<MaintenanceTypeFormBody>
      defaultValues={defaultValues}
      submitText={i18n.t.common.save}
      disabled={isDisabled}
      onSubmit={() => onSubmit}
    >
      {({ register, reset, formState: { errors } }) => {
        useEffect(() => {
          reset(defaultValues);
        }, [maintenanceType]);

        return (
          <FormFieldsContainer>
            <FormField label={i18n.t.common.name} error={errors.name}>
              {({ labelId, isInvalid }) => (
                <Input
                  id={labelId}
                  isInvalid={isInvalid}
                  disabled={isDisabled || isLoading}
                  {...register("name", {
                    required: true,
                  })}
                />
              )}
            </FormField>
          </FormFieldsContainer>
        );
      }}
    </Form>
  );
};

export default MaintenanceTypeForm;
